import { render, staticRenderFns } from "./QuestionShow.vue?vue&type=template&id=1c2fbcec&"
import script from "./QuestionShow.vue?vue&type=script&lang=js&"
export * from "./QuestionShow.vue?vue&type=script&lang=js&"
import style0 from "./QuestionShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports